import type { HtmlSerializerProps } from './html-serializer';
import { Logger } from './logger';

interface ParsedMetaLanguage {
  title?: unknown;
  type?: unknown;
  value?: unknown;
}

interface CustomMetaLanguageSchema extends ParsedMetaLanguage {
  type: 'custom';
  value: HtmlSerializerProps['content'][];
}

export interface CustomMetaLanguage {
  content: HtmlSerializerProps['content'][];
  title?: string;
}

const isParsedMetaLanguage = (value: unknown): value is ParsedMetaLanguage =>
  typeof value === 'object' && value !== null;

const isCustomMetaLanguage = (
  value: unknown
): value is CustomMetaLanguageSchema =>
  isParsedMetaLanguage(value) &&
  value.type === 'custom' &&
  Array.isArray(value.value);

export const parseCustomMetaLanguage = (
  message?: string
): CustomMetaLanguage | undefined => {
  if (!message) return undefined;

  const sanitizedMessage = message.replace(/(\r\n|\n|\r)/gm, '');
  const jsonString = sanitizedMessage.match(
    /<PrescreenJson>(.*)<\/PrescreenJson>/
  )?.[1];

  if (jsonString === undefined) return undefined;

  try {
    const schema: unknown = JSON.parse(jsonString);

    if (!isCustomMetaLanguage(schema)) {
      return undefined;
    }

    return {
      content: schema.value,
      title: typeof schema.title === 'string' ? schema.title : undefined,
    };
  } catch (error) {
    Logger.log(error);
    return undefined;
  }
};
